import { createAsyncActionTypes } from '../../helpers';

const domain = 'photos';

const fetchPhotosAndResources = createAsyncActionTypes(domain, 'fetchPhotosAndResources');
const addPhotoByProjectId = createAsyncActionTypes(domain, 'addPhotoByProjectId');
const addMultiplePhotos = createAsyncActionTypes(domain, 'addMultiplePhotos');
const updateMultiplePhotos = createAsyncActionTypes(domain, 'updateMultiplePhotos');
const updatePhoto = createAsyncActionTypes(domain, 'updatePhoto');
const deletePhotoWithIndexShifting = createAsyncActionTypes(domain, 'deletePhotoWithIndexShifting');
const sendPhotosUploadInfo = createAsyncActionTypes(domain, 'sendPhotosUploadInfo');
const replaceCoverPhoto = createAsyncActionTypes(domain, 'replaceCoverPhoto');
const chooseCoverPhoto = createAsyncActionTypes(domain, 'chooseCoverPhoto');
const getCoverPhotosByProjectId = createAsyncActionTypes(domain, 'getCoverPhotosByProjectId');
const getCoverPhotos = createAsyncActionTypes(domain, 'getCoverPhotos');
const deleteCoverPhotos = createAsyncActionTypes(domain, 'deleteCoverPhotos');
const addCoverPhoto = createAsyncActionTypes(domain, 'addCoverPhoto');

export default {
  fetchPhotosAndResources,
  addPhotoByProjectId,
  addMultiplePhotos,
  updateMultiplePhotos,
  updatePhoto,
  deletePhotoWithIndexShifting,
  sendPhotosUploadInfo,
  replaceCoverPhoto,
  chooseCoverPhoto,
  getCoverPhotosByProjectId,
  getCoverPhotos,
  deleteCoverPhotos,
  addCoverPhoto,
};
